import {Button, Menu, Typography} from "@mui/material";
import {RichTreeView} from "@mui/x-tree-view";
import {useEffect, useMemo, useState} from "react";
import {buildLabeledFilterTree, buildTreeIdToLabelMap} from "../../utils/filters";

export const ProductPicker = ({products, businessUnits, productSetter, filters}) => {
    const [anchorElement, setAnchorElement] = useState(null);
    const [selectedIds, setSelectedIds] = useState(['ALL']);
    const [selectedName, setSelectedName] = useState('ALL');

    const treeItems = useMemo(() => {
        const labeledProducts = buildLabeledFilterTree(
            products,
            businessUnits || [],
            filters.businessUnitId
        );
        return [{id: 'ALL', label: 'ALL'}, ...labeledProducts];
    }, [products, businessUnits, filters.businessUnitId]);

    const productIdToNameMap = useMemo(
        () => buildTreeIdToLabelMap(treeItems),
        [treeItems]
    );

    useEffect(() => {
        if (!filters.productCategoryId) {
            setSelectedIds(['ALL']);
            setSelectedName('ALL');
            return;
        }
        setSelectedIds([filters.productCategoryId]);
        setSelectedName(productIdToNameMap[filters.productCategoryId] ?? 'ALL');
    }, [filters.productCategoryId, productIdToNameMap]);

    const handleClick = (event) => {
        setAnchorElement(event.currentTarget);
    };

    const handleSelection = (event, id) => {
        setAnchorElement(null);
        const selectedId = Array.isArray(id) ? id[0] : id;
        if (selectedId === selectedIds[0]) {
            return;
        }
        setSelectedIds([selectedId]);
        setSelectedName(productIdToNameMap[selectedId] ?? 'ALL');
        productSetter(selectedId);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div>
            <Typography variant="h7" display="inline">Product:</Typography>
            <Button onClick={handleClick}>{selectedName}</Button>
            <Menu id="PickerMenu" anchorEl={anchorElement} keepMounted open={Boolean(anchorElement)}
                  onClose={handleClose}>
                <RichTreeView
                    items={treeItems}
                    selectedItems={selectedIds}
                    onSelectedItemsChange={handleSelection}
                    checkboxSelection
                />
            </Menu>
        </div>
    );
};
